
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h38v38H0z"}}),_c('path',{attrs:{"d":"M13.835 7.398a.404.404 0 01.403-.379h10.524c.213 0 .39.166.403.379l.619 9.894a6.296 6.296 0 11-12.568 0l.619-9.894zM19.5 23.577V30.5m0 0l-5.192 1.73h10.384L19.5 30.5z","stroke":"#000","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M13.5 15s2.039 2.23 4.846 2.23c3.462 0 5.192-1.73 6.923-1.73","stroke":"#000","stroke-width":"1.5"}})])
      }
    
      }
    